import { Skeleton, SkeletonRegion } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface Props {
  rows?: number;
  /** `divided` = flat rows split by hairlines; `cards` = bordered row cards. */
  variant?: "divided" | "cards";
  className?: string;
}

export default function ListRowsSkeleton({
  rows = 3,
  variant = "divided",
  className,
}: Props) {
  return (
    <SkeletonRegion
      className={cn(
        variant === "divided"
          ? "divide-y divide-border"
          : "flex flex-col gap-2",
        className,
      )}
    >
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className={cn(
            "flex items-center justify-between gap-3",
            variant === "divided"
              ? "py-3"
              : "rounded-xl border border-border bg-card p-3.5",
          )}
        >
          <div className="flex-1 space-y-2">
            <Skeleton className="h-3.5 w-2/5" />
            <Skeleton className="h-3 w-1/4" />
          </div>
          <Skeleton className="h-4 w-16" />
        </div>
      ))}
    </SkeletonRegion>
  );
}
